import { dateUtils } from './dateUtils';

export const setCookie = async (key: string, value: string, options: { maxAge?: number; path?: string } = {}) => {
  if (typeof window === 'undefined') {
    const { cookies } = await import('next/headers');
    cookies().set(key, value, options);
  } else {
    const { maxAge = 3600, path = '/' } = options;

    const expires = dateUtils.parse.safe(Date.now() + maxAge * 1000)?.toUTCString() ?? '';
    document.cookie = `${key}=${value}; path=${path}; expires=${expires};`;
  }
};

export const getCookie = async (key: string) => {
  if (typeof window === 'undefined') {
    const { cookies } = await import('next/headers');
    return cookies().get(key)?.value;
  } else {
    const reg = new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*=\\s*([^;]*).*$)|^.*$`);
    return document.cookie.replace(reg, '$1');
  }
};
